module.exports = __webpack_public_path__ + "static/media/SF2011_01.458b4222.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/SF2011_01.jpg
// module id = 378
// module chunks = 0